module.exports = Object.freeze({
   FILE_STORAGE: 'Quản lý tài liệu',
   SENDER:'Người gửi',
   FROM_DATE: 'Từ Ngày',
   TO_DATE: 'Đến Ngày',
   SENT_DATE: 'Ngày gửi',
   PERIOD_OF_TIME: 'Chọn khoảng thời gian',
   READ_DOCUMENT: 'Xem trước',
   DOWNLOAD_DOCUMENT:'Tải xuống',
   ASK_DOWNLOAD: 'Bạn có muốn tiếp tục tải file xuống không?',
   ASK_DOWNLOAD_QRCODE: 'Bạn có muốn tiếp tục tải qrcode xuống không?',
   NO_DATA_TO_EXPORT: 'Không có dữ liệu để xuất file',
   NO_FILE: 'Không có tài liệu',
});